<mat-dialog-actions class="justify-content-between">
    <h3>{{ (readOnly ? 'LABEL.VIEW_LABEL' : (isEditMode ? 'LABEL.UPDATE_LABEL' : 'LABEL.ADD_LABEL')) | translate }} {{
        'ENTITY.IPD' | translate }}</h3>
    <div class="d-flex justify-content-center">
        <a mat-icon-button color="primary" (click)="onPrint()" *ngIf="isEditMode && onPrintCallback">
            <i-tabler name="printer" class="icon-25 d-flex text-primary"></i-tabler>
        </a>
        <button mat-icon-button mat-dialog-close>
            <i-tabler name="x" class="icon-25 d-flex"></i-tabler>
        </button>
    </div>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <div *ngIf="isLoading" class="loader-wrapper">
        <mat-spinner diameter="40"></mat-spinner>
    </div>

    <form [formGroup]="ipdform" *ngIf="!isLoading">

        <div class="row">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.IPD_DATE' | translate }}</mat-label>
                    <input matInput [matDatepicker]="IPDpicker" formControlName="ipdDate" [min]="minDate" required
                        [max]="maxDate" placeholder="DD/MM/YYYY" [readonly]="readOnly">
                    <mat-datepicker-toggle matIconSuffix [for]="IPDpicker"
                        [disabled]="readOnly"></mat-datepicker-toggle>
                    <mat-datepicker #IPDpicker [color]="'primary'"></mat-datepicker>
                    <mat-error
                        *ngIf="ipdform.get('ipdDate')?.invalid && (ipdform.get('ipdDate')?.dirty || ipdform.get('ipdDate')?.touched)">
                        <span *ngIf="ipdform.get('ipdDate')?.errors?.['required']">{{ 'REQUIRED.SELECT_DATE' |
                            translate }}</span>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.IPD_TIME' | translate }}</mat-label>
                    <input type="time" matInput placeholder="{{ 'LABEL.IPD_TIME' | translate }}"
                        formControlName="ipdTime" [readonly]="readOnly" />
                    <mat-error *ngIf="ipdform.get('ipdTime')?.hasError('required') && 
                    (ipdform.get('ipdTime')?.dirty || ipdform.get('ipdTime')?.touched)">
                        {{ 'REQUIRED.SELECT_TIME' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.PARENT_GUARDIAN_NAME_ADDRESS' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.PARENT_GUARDIAN_NAME_ADDRESS' | translate }}" cols="5"
                        rows="3" formControlName="nameAndAddress" maxlength="500" [readonly]="readOnly"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.PARENT_GUARDIAN_CONTACT' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'LABEL.PARENT_GUARDIAN_CONTACT' | translate }}"
                        formControlName="contact" maxlength="10" appAllowOnlyDigits [readonly]="readOnly" />
                </mat-form-field>
            </div>
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.MEDICLAIM' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'ENTITY.MEDICLAIM' | translate }}"
                        [matAutocomplete]="automediclaim" [formControl]="mediclaimCtrl" #mediclaimInput
                        [readonly]="readOnly" />

                    <mat-autocomplete #automediclaim="matAutocomplete" [displayWith]="displayMediclaim"
                        (optionSelected)="onMediClaimSelected($event.option.value)">
                        <mat-option *ngFor="let mediclaim of filteredMediClaim$ | async" [value]="mediclaim">
                            {{ mediclaim.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.POLICY_NO' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'LABEL.POLICY_NO' | translate }}"
                        formControlName="policyNumber" maxlength="50" [readonly]="readOnly" />
                    <mat-error *ngIf="ipdform.get('policyNumber')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.WARD' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'ENTITY.WARD' | translate }}"
                        [matAutocomplete]="autoward" [formControl]="wardCtrl" #wardInput required
                        [readonly]="readOnly" />

                    <mat-autocomplete #autoward="matAutocomplete" [displayWith]="displayward"
                        (optionSelected)="onWardSelected($event.option.value)">
                        <mat-option *ngFor="let ward of filteredward$ | async" [value]="ward">
                            {{ ward.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="wardCtrl.hasError('required') && 
                    (wardCtrl.dirty || wardCtrl.touched)">
                        {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.ROOM_NUMBER' | translate }}</mat-label>

                    <input type="text" matInput [matAutocomplete]="roomAuto" formControlName="roomId"
                        [readonly]="readOnly" />

                    <mat-autocomplete #roomAuto="matAutocomplete" [displayWith]="displayRoomName">
                        <mat-option *ngFor="let room of filteredRooms$ | async" [value]="room">
                            {{ room.childValue }} (Room No: {{ room.name }})
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="ipdform.get('roomId')?.hasError('required') && 
                    (ipdform.get('roomId')?.dirty || ipdform.get('roomId')?.touched)">
                        {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.BED' | translate }}</mat-label>

                    <input type="text" matInput [matAutocomplete]="bedAuto" formControlName="bedId"
                        [readonly]="readOnly" />

                    <mat-autocomplete #bedAuto="matAutocomplete" [displayWith]="displayBedNumber">
                        <mat-option *ngFor="let bed of filteredBeds$ | async" [value]="bed">
                            {{ bed.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="ipdform.get('bedId')?.hasError('required') && 
                    (ipdform.get('bedId')?.dirty || ipdform.get('bedId')?.touched)">
                        {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>

        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DIAGNOSIS' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.DIAGNOSIS' | translate }}" cols="5" rows="3"
                        formControlName="provisionalDiagnosis" [readonly]="readOnly"></textarea>
                    <mat-error *ngIf="ipdform.get('provisionalDiagnosis')?.hasError('required') && 
                    (ipdform.get('provisionalDiagnosis')?.dirty || ipdform.get('provisionalDiagnosis')?.touched)">
                        {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' |
                translate}}</button>
            <button *ngIf="!readOnly" mat-flat-button color="primary" (click)="onSaveIPD()"
                [disabled]="ipdform.invalid">{{'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>